import React from "react";
import ReactDOM from "react-dom";
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import 'antd/dist/antd.css';
import { Provider } from 'react-redux'
import store from './redux/store'
import AppRouter from './containers/AppRouter';
import "./i18n"
import { initTracing } from "./utils/tracing";

initTracing();



ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <AppRouter/>
        </Provider>
        <ToastContainer
            hideProgressBar={true}
        />
    </React.StrictMode>,
    document.getElementById("root")
);
reportWebVitals();
